import React from "react";
import Button from "sushiweb/Button";
import FilterButton from "../../components/Common/FilterButton";
import {
  getFleetCoachList,
  setFleetCoachActiveObject,
} from "../../store/actions/FleetCoach";
import { FlexContainer, Heading } from "../../constants/assets/containers";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FleetCoachListView from "../../components/FleetCoach";
import ListPagination from "../../components/Common/ListPagination";
import FleetCoachModal from "../../components/FleetCoach/FleetCoachModal";
import { useHistory, useParams } from "react-router-dom";
import { getPath } from "../../utils";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";
import Permission from "../../components/Common/Permission";
const FleetCoach = (props) => {
  const params = useParams();
  const history = useHistory();
  const {
    getFleetCoachList,
    fleetCoachList,
    prevPage,
    nextPage,
    activeFilters,
    setFleetCoachActiveObject,
  } = props;
  const [modalState, setModalState] = React.useState(false);
  const [activeId, setActiveId] = React.useState(null);
  const [currentPage, setCurrentPage] = React.useState(1);
  const shouldRenderList = getPath(params, "id", undefined) === undefined;
  const allActions = MenuActionsMappings[MenuNames.FLEET_COACH];
  React.useEffect(() => {
    if (shouldRenderList === true) {
      getFleetCoachList(currentPage, {});
    } else {
      handleClick("Edit", params.id);
    }
  }, []);

  const handleNavClick = (action) => {
    if (action === "prev") {
      getFleetCoachList(currentPage - 1, activeFilters);
      setCurrentPage(currentPage - 1);
    } else {
      getFleetCoachList(currentPage + 1, activeFilters);
      setCurrentPage(currentPage + 1);
    }
  };

  // type => modalType
  // id for which obj we have to handle
  const handleClick = (type, id) => {
    setActiveId(id);
    setModalState(type);
  };

  const handleClose = () => {
    setModalState(false);
    setFleetCoachActiveObject({});
    if (
      history.location.pathname !== "/fleet-coach" &&
      getPath(fleetCoachList, "length", -1) > 0
    ) {
      //no page refresh, hence redux store will persist
      window.history.pushState("", "", "/fleet-coach");
    } else if (
      history.location.pathname !== "/fleet-coach" &&
      getPath(fleetCoachList, "length", -1) === 0
    ) {
      // clear everything and page refresh
      history.push("/fleet-coach");
    }
  };

  return (
    <React.Fragment>
      <FlexContainer align="flex-start">
        <Heading>Fleet Coach</Heading>
        <div className="actionBar mb-20 flex items-center justify-end">
          <Permission requiredPerms={[allActions.LIST]}>
            <FilterButton
              activeFilters={activeFilters}
              data-testid="fleetCoachFilterButton"
              handleClick={() => handleClick("Filter", null)}
            />
          </Permission>
          <Permission requiredPerms={[allActions.CREATE]}>
            <Button
              onClick={() => handleClick("Add", null)}
              className="sushi-btn ml-12"
              data-testid="fleetCoachCreationButton"
            >
              Add New
            </Button>
          </Permission>
        </div>
      </FlexContainer>
      <FleetCoachListView fleetCoachList={fleetCoachList} />
      <ListPagination
        nextPage={nextPage}
        prevPage={prevPage}
        handleNavClick={handleNavClick}
      />
      {modalState && (
        <FleetCoachModal
          activeId={activeId}
          modalState={modalState}
          handleClose={handleClose}
        />
      )}
    </React.Fragment>
  );
};

function mapStateToProps(state) {
  const { FleetCoach } = state;
  return {
    fleetCoachList: FleetCoach.fleetCoachList,
    prevPage: FleetCoach.prevPage,
    nextPage: FleetCoach.nextPage,
    activeFilters: FleetCoach.activeFilters,
  };
}
function mapDispatchToProps(dispatch) {
  return {
    getFleetCoachList: bindActionCreators(getFleetCoachList, dispatch),
    setFleetCoachActiveObject: bindActionCreators(
      setFleetCoachActiveObject,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FleetCoach);
